export const ApiConfig = {
    mainData: {
        "url": "site/main",
        "method": "post"
    },
    pageList: {
        "url": "site/getpage",
        "method": "get"
    },
    defaultCurrency: {
        "url": "site/landing/getDefaultCurrency?name=",
        "method": "get"
    },
    defaultLanguage: {
        "url": "site/landing/getDefaultLanguage?name=",
        "method": "get"
    },
    landingData: {
        "url": "site/landing/landingdata",
        "method": "post"
    },
    getPage: {
        "url": "site/pages/getpage",
        "method": "post"
    },
    subscribeNewsletter: {
        "url": "site/landing/subscription",
        "method": "post"
    },
    checkServiceArea: {
        "url": "site/booking/check-service-area",
        "method": "post"
    },
    checkEmail: {
        "url": "site/users/checkemail",
        "method": "post"
    },
    checkUserName: {
        "url": "site/users/checkusername",
        "method": "post"
    },
    checkPhoneNo: {
        "url": "site/users/phonecheck",
        "method": "post"
    },
    checkReferalCode: {
        "url": "site/users/checkreferal",
        "method": "post"
    },
    registerUser: {
        "url": "siteregister",
        "method": "post"
    },
    bookingCategories: {
        "url": "site/booking/categories",
        "method": "post"
    },
    showAllTasker: {
        "url": "site/booking/show_all_tasker_schedule",
        "method": "post"
    },
    UserAddress: {
        "url": "site/booking/job-details-init",
        "method": "post"
    },
    getCampaign: {
        'url': "site/booking/getcampaign",
        "method": "post"
    },
    uploadImge: {
        'url': "site/booking/upload-images",
        "method": "post"
    },
    searchTasker: {
        'url': "site/booking/search-tasker",
        'method': "post"
    },
    Booking_info:
    {
        'url': "site/booking/booking-info",
        'method': "post"
    },
    ConirmBooking: {
        'url': 'site/booking/confirm-booking',
        'method': 'post'

    },
    profile: {
        'url': 'site/task/taskprofileinfo',
        'method': 'post'
    },
    TaskerReview: {
        'url': 'site/task/taskerreviews',
        'method': 'post'
    },
    taskerEditProfile: {
        url: 'site/account/tasker/settings/save',
        method: 'post'
    },
    Nexavailableday: {
        'url': 'site/booking/next_availability_tasker_schedule',
        'method': 'post'
    },
    changePassword: {
        url: 'site/account/password/save',
        method: 'post'
    },
    cardDetail: {
        url: 'site/saveusercardinfo',
        method: 'post'
    },
    editProfile: {
        url: 'site/account/settings/save',
        method: 'post'
    },
    cancelProject: {
        url: 'site/account/getcancelreason',
        method: 'post'
    },
    deleteAccount: {
        url: 'site/account/deleteAccount',
        method: 'post'
    },
    userCanceltask: {
        url: 'site/account/usercanceltask',
        method: 'post'
    },
    currentUser: {
        url: 'site/users/currentUser',
        method: 'post'
    },
    taskerLogin: {
        url: 'site/taskerlogin',
        method: 'post'
    },
    taskerpassword: {
        url: 'site/saveforgotpasswordinfo',
        method: 'post'
    },
    getReview: {
        url: 'site/account/getreview',
        method: 'post'
    },
    getcurrentplan: {
        url: 'site/account/getcurrentplan',
        method: 'post'
    },
    getPackList: {
        url: 'site/account/getPackList',
        method: 'post'
    },
    cancelsubscription: {
        url: 'site/account/cancelsubscription',
        method: 'post'
    },
    getTaskDetailsBytaskidoffline: {
        url: 'site/account/getTaskDetailsBytaskidoffline',
        method: 'post'

    },
    getTaskList: {
        method: 'post',
        url: 'site/account/getTaskList'
    },
    getFilteredTaskList : {
        method : 'post',
        url : 'site/account/getFilteredTasks'
    },
    estimationpdf: {
        method: 'post',
        url: 'site/account/estimations_pdf'
    },
    generateinvoice_pdf: {
        method: 'post',
        url: 'site/account/generateinvoice_pdf'
    },
    get_job_details: {
        method: 'post',
        url: 'site/account/get_job_details'
    },
    gettaskreview: {
        method: 'post',
        url: 'site/account/gettaskreview'
    },
    getSocialNetworkList: {
        method: 'post',
        url: 'site/account/getSocialNetworkList'
    },
    addReview: {
        method: 'post',
        url: 'site/account/addReview'
    },
    sendChangeorderOtp: {
        method: 'post',
        url: 'site/account/send-changeorder-otp'
    },
    verifyChangeorderOtp: {
        method: 'post',
        url: 'site/account/verify-changeorder-otp'
    },
    client_changeorderapproval: {
        method: 'post',
        url: 'site/account/client-changeorderapproval'
    },
    show_taskerschedule: {
        method: 'post',
        url: 'site/account/show-tasker-schedule'
    },
    client_approval: {
        method: 'post',
        url: 'site/account/estimation-client-approval'
    },
    paymentmode: {
        method: 'post',
        url: 'site/account/paymentmode'
    },
    gettaskbyid: {
        method: 'post',
        url: 'site/account/gettaskbyid'
    },
    getUserId:{
        method:'post',
        url:'site/account/get-user-id'
    },
    updateloyaltycash: {
        method: 'post',
        url: 'site/account/updateloyaltycash'
    },
    stripecard_list: {
        method: 'post',
        url: 'site/account/payment/stripe-card-list'
    },
    confirmtask: {
        method: 'post',
        url: 'site/account/confirmtask'

    },
    apply_coupon: {
        method: 'post',
        url: 'site/account/apply-coupon'

    },
        createCheckoutSession:{
        method:"post",
        url:"site/account/createCheckoutSession"
    },
    getSessionStatus:{
        method:"post",
        url:"site/account/getSessionStatus"
    },
    prePaymentCheckoutSession:{
        method:"post",
        url:"site/account/prePaymentCheckoutSession"
    },
    paymentSessionStatus:{
        method:"post",
        url:"site/account/paymentSessionStatus"
    },
    updatePrePaymentAudit:{
        method:"post",
        url:"site/account/updatePrePaymentAudit"
    },
    updatePaymentAudit:{
        method:"post",
        url:"site/account/updatePaymentAudit"
    },
    getPublishKey:{
        method:"post",
        url:"site/account/getPublishKey"
    },
    stripe_add_card: {
        method: 'post',
        url: 'site/account/payment/stripe-add-card'
    },
    subscriptionDetails: {
        method: 'post',
        url: 'site/account/subscriptionDetails'
    },
    stripe_payment_process: {
        method: 'post',
        url: 'site/pre_amount_save/stripe-payment-process'
    },
    stripe_delete_card: {
        method: 'post',
        url: 'site/account/payment/stripe-delete-card'
    },
    stripe_default_card: {
        method: 'post',
        url: 'site/account/payment/stripe-default-card'
    },
    get_loyalty: {
        method: 'post',
        url: 'site/account/get-loyalty'
    },
    forgotPassword: {
        method: 'post',
        url: 'site/saveforgotpwduser'
    },
    savepassword: {
        method: 'post',
        url: 'site/forgotpwdmailuser'
    },
    gettaskdetails: {
        method: 'post',
        url: 'site/account/gettaskbyid'
    },
    paymentmode_list: {
        method: 'post',
        url: 'site/account/paymentmode_list'
    },
    getdonateandtips: {
        "url": "site/account/get_donate_and_tips",
        "method": "get"
    },
    add_invoice_details: {
        method: 'post',
        url: 'site/account/add_invoice_details'
    },
    add_card: {
        method: 'post',
        url: 'site/account/payment/addstripecardbysite'
    },
    paymentconfirmtask: {
        method: 'post',
        url: 'site/account/paymentconfirmtask'
    },
    getTaskReviewAccountById: {
        method: 'post',
        url: 'site/account/gettaskbyid'
    },
    savetaskerpassword: {
        method: 'post',
        url: 'site/forgotpwdmailtasker'
    },
    getTaskDetailsBytaskid: {
        method: 'post',
        url: 'site/account/getTaskDetailsBytaskidoffline'
    },
    stripepaymentprocess: {
        method: 'post',
        url: 'site/pre_amount/stripe-payment-process'
    },
    addAddress: {
        method: 'post',
        url: 'site/user/addaddress'
    },
    landingsetting: {
        method: 'post',
        url: 'site/categories/edit_landing_setting'

    },
    save_landingpage: {
        method: 'post',
        url: "site/categories/savecategorylanding_settings"
    },
    approvechangeorderoffline: {
        method: 'post',
        url: 'site/account/client-changeorderapproval-offline'
    },
    landing_slug: {
        method: 'post',
        url: 'site/category/getcategory'
    },
    mobile_preview: {
        method: "post",
        url: "site/categories/savecategorymobilepreview_data"
    },
    franchiseelanding: {
        method: "post",
        url: "site/categories/getfrancategorylandingsetting"
    },
    savelandingpage: {
        method: "post",
        url: "site/categories/savelandingsetting"

    },
    savemobilepreview: {
        method: "post",
        url: 'site/categories/savecategorymobilepreview_data'
    },
    chechFranchisee:{
        method:"post",
        url:"site/category/checkfranchisee"
    },
    loyaltyCompletePayment:{
        method:"post",
        url:"site/account/loyaltyCompletePayment"
    },
    updateuserdetails:{
        method:"post",
        url:"site/user/updateUser"
    },
    updateFacebookIDUser:{
        method:"post",
        url:"site/user/updateFacebookIDUser"
    },
    contactAs:{
        method:"post",
        url:"site/contact/savecontactusmessage"
    },
    hmpsetting: {
        url: 'get/hmp/settings',
        method: 'get'
    }

    
}

